import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createCurrentHOC } from '@beef/redux';
import { createSelector } from '@reduxjs/toolkit';
import { getTariffValueGroups } from "./selectors";
import { getTariffValues } from "./tariffSelectors";
export var getTariffGroupedValues = createSelector([getTariffValueGroups, getTariffValues], function (groups, values) {
  return groups.map(function (group) {
    return _objectSpread(_objectSpread({}, group), {}, {
      values: values.filter(function (val) {
        return val.group === group.kind;
      })
    });
  }).filter(function (group) {
    return group.values.length;
  });
});

// @ts-expect-error fix later
var _createCurrentHOC = createCurrentHOC(getTariffGroupedValues, function (item) {
    return item.kind;
  }),
  _createCurrentHOC2 = _slicedToArray(_createCurrentHOC, 2),
  __group = _createCurrentHOC2[0],
  withTariffValueGroupMapper = _createCurrentHOC2[1];
export { __group, withTariffValueGroupMapper };
var getGroup = __group;
export var getValueGroupTitle = function getValueGroupTitle(state) {
  return getGroup(state).title;
};
export var getCurrentTariffValues = function getCurrentTariffValues(state) {
  return getGroup(state).values;
};